
import FormRow from 'modules/core/components/FormRow'
import DayPicker from 'modules/core/components/Inputs/DayPicker'
import i18n from 'modules/core/lib/i18n'

import type CompanyHolidayForm from 'modules/timeoff/lib/CompanyHoliday'

interface Props {
  form: CompanyHolidayForm
}

export function OneDay({ form }: Props) {
  return (
    <FormRow>
      <DayPicker field={form.get('date')} label={i18n.t('settings.time_off.date')} />
    </FormRow>
  )
}
